var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99996 6.00075L0.756958 1.75775L2.17196 0.34375L4.99996 3.17275L7.82796 0.34375L9.24296 1.75775L4.99996 6.00075Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown2);
export default __webpack_public_path__ + "static/media/angleDown2.844bb13ba9bac91883b5c38bf6fcc36c.svg";
export { ForwardRef as ReactComponent };